import { Currency } from "@redotech/money/currencies";
import { MetricDefinitionPartZodSchema } from "@redotech/redo-model/checkouts/metric-definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getCheckoutSplitSummaryMetrics = {
  name: "getCheckoutSplitSummaryMetrics" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.object({
    displayedAnnualizedRevenueImpact: z.object({
      value: z.string(),
      calculationUsed: z.array(MetricDefinitionPartZodSchema).optional(),
      shopCurrency: createEnum(Currency),
    }),
    displayedTotalCheckoutVisits: z.object({ value: z.string() }),
    displayedTestDurationDays: z.object({ value: z.string() }),
  }),
};
